export default {"src":"/_next/static/media/food.5bb09268.svg","height":55,"width":68,"blurWidth":0,"blurHeight":0};